<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
  >
    <el-table :data="personList" border size="small">
      <el-table-column prop="userName" label="人员" width="100" />
      <el-table-column prop="stationName" label="岗位" width="100" />
      <el-table-column prop="businessNum" label="订单数" width="80" />
      <el-table-column v-if="showGrossProfit" prop="grossProfitTotal" label="毛利总额" width="120">
        <template slot-scope="scope">{{ formatGrossProfitTotal(scope.row.grossProfitTotal) }}</template>
      </el-table-column>
      <el-table-column prop="provisionAmount" label="提成金额" width="120">
        <template slot-scope="scope">{{ formatAmount(scope.row.provisionAmount) }}</template>
      </el-table-column>
      <el-table-column label="规则明细" min-width="200">
        <template slot-scope="scope">
          <div v-for="(r, i) in scope.row.ruleDetails" :key="i" class="rule-line">
            {{ r.ruleName }}: {{ formatAmount(r.amount) }}
            <span v-if="r.calcFormula || r.formula" class="formula">({{ formatFormula(r.calcFormula || r.formula) }})</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { queryBatchPersonDetails } from '@/api/provision/provisionData'
import * as ProvisionConstants from '@/class/cargo/model/parameters/ProvisionConstants'

export default {
  name: 'PersonDetailDialog',
  props: {
    visible: { type: Boolean, default: false },
    provisionUuid: { type: String, default: '' },
    stationName: { type: String, default: '' }
  },
  data() {
    return {
      personList: []
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    },
    dialogTitle() {
      return '人员提成明细'
    },
    showGrossProfit() {
      return ProvisionConstants.isConfigurableStation(this.stationName)
    }
  },
  watch: {
    visible(val) {
      if (val && this.provisionUuid) {
        this.loadData()
      }
    }
  },
  methods: {
    async loadData() {
      const res = await queryBatchPersonDetails(this.provisionUuid)
      if (res.ok) {
        this.personList = res.data || []
      }
    },
    formatAmount(val) {
      if (val === null || val === undefined || val === '') return '-'
      return Number(val).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatGrossProfitTotal(val) {
      if (val === null || val === undefined || val === '' || Number(val) === 0) return '-'
      return this.formatAmount(val)
    },
    formatFormula(formula) {
      if (!formula) return ''
      return String(formula).replace(/(总计息毛利|组内他人毛利|计息毛利)(-?\d+(?:\.\d+)?)/g, (match, label, amount) => {
        return label + Number(amount).toFixed(2)
      })
    }
  }
}
</script>

<style scoped>
.rule-line { font-size: 12px; line-height: 1.6; }
.formula { color: #909399; }
</style>
